import React from 'react';
import { testimonials } from '../data/content';
export function Testimonials() {
  // Hidden until authentic SCIENCES PRÊTES reviews are added in data/content.ts
  if (testimonials.length === 0) return null;
  return <section className="w-full border-t border-ink/10 bg-paper px-8 py-24 sm:px-14 sm:py-32" data-id="element-213" data-mp="3fym7sltdl44v">
      <div className="mx-auto max-w-6xl" data-id="element-214" data-mp="3azjc3rzaca9k">
        <h2 className="font-display text-[2.6rem] leading-[1.02] tracking-tight text-ink sm:text-6xl" data-id="element-215" data-mp="3ayhypgusrboo">
          Ce qu’en disent <em className="text-pen" data-id="element-216" data-mp="31zwb37agx6h1">les enseignants</em>
        </h2>

        <div className="mt-14 grid gap-10 border-t border-ink/15 pt-10 sm:grid-cols-3" data-id="element-217" data-mp="31yl7b7h0vypx">
          {testimonials.map(item => <figure key={item.name} className="flex h-full flex-col" data-id="element-218" data-mp="2x2mnlx6n34vu">
              <div className="text-sm text-amber-500" aria-label="5 étoiles sur 5" data-id="element-219" data-mp="2s39ooe2hu7cw">
                <span aria-hidden="true" data-id="element-220" data-mp="v8dite99jy8p">★★★★★</span>
              </div>
              <blockquote className="mt-4 flex-1 font-display text-2xl leading-snug text-ink" data-id="element-221" data-mp="q9tytje8cwiz">
                «&nbsp;{item.quote}&nbsp;»
              </blockquote>
              <figcaption className="mt-6 text-sm" data-id="element-222" data-mp="h818fqfnqklj">
                <span className="font-semibold text-ink" data-id="element-223" data-mp="m62p64pm27tu">{item.name}</span>
                <span className="text-ink/60" data-id="element-224" data-mp="780kfr6ufgb0"> — {item.location}</span>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}